import styled, {css} from 'styled-components';
import {transparentize} from 'polished';
import {transition} from 'helpers/css';
import {ButtonProps, ButtonVariant} from './types';

export const Wrapper = styled.button<ButtonProps>`
  ${transition()};
  border: 2px solid transparent;
  border-radius: 5px;
  box-sizing: border-box;
  padding: 6px 10px;
  
  gap: 8px;
  align-items: center;
  grid-auto-flow: column;
  display: inline-grid;

  line-height: 16px;
  font-size: 12px;
  
  ${({variant}) => {
    switch (variant) {
      case ButtonVariant.Default: return css`
        background-color: ${({theme}) => `
          ${transparentize(.95, theme.colors.white)};
        `};
        
        &:hover,
        &:focus-within {
          background-color: ${({theme}) => `
            ${transparentize(.98, theme.colors.white)};
          `};  
        }
      `;
      case ButtonVariant.Outline: return css`
        border-color: ${({theme}) => `
          ${transparentize(.98, theme.colors.white)};
        `};
        
        &:hover {
          background-color: ${({theme}) => `
            ${transparentize(.98, theme.colors.white)};
          `};
        }
      `;
    }
  }};
`;
